import React from 'react';
import { Body5, Container } from '@ui';
import { AUDIT_TABLE_MIN_WIDTH, AuditEventHeader, AuditEventRow } from './AuditEventRow';
import { SectionHead, Table, TableScroll } from './styles';

// The `history` list a value or an unmapped row carries: the same event row the audit page draws,
// so an event reads the same everywhere. Newest first is the server's order and is kept.
export const HistoryList = ({ events = [], heading = 'History' }) => (
  <div>
    <SectionHead heading={heading} subtext="Every decision and correction on this row, newest first" />
    <Container top={12}>
      {events.length === 0 ? (
        <Body5 isLowContrast>No history yet.</Body5>
      ) : (
        <TableScroll>
          <Table $minWidth={AUDIT_TABLE_MIN_WIDTH}>
            <AuditEventHeader />
            {events.map((event) => (
              <AuditEventRow key={event.id ?? `${event.at}-${event.event_type}`} event={event} />
            ))}
          </Table>
        </TableScroll>
      )}
    </Container>
  </div>
);
